.row_global_card {
	margin-right: 5px !important;
	margin-left: 5px !important;
	margin-top: 5px;
	height: 100%;

	@media screen and (max-width: 950px) {
		margin-right: 10px !important;
		margin-left: 10px !important;

		margin-bottom: 3em;
	}

	.col_base {
		margin-bottom: 10px;
		padding-right: 0px;
		padding-left: 0px;

		@media screen and (max-width: 950px) {
			max-height: initial;
			min-height: initial;
		}

		.header {
			height: 42%;
			animation: fade-in 1s;

			&.collapse {
				height: 0%;
			}

			.headerRight {
				border-left: 0.5px solid #d3d3d3;
				padding-left: 0px;
				padding-right: 0px;

				@media screen and (max-width: 950px) {
					border-left: 0px solid white;
				}
			}

			.headerLeft {
				border-right: 0.5px solid #d3d3d3;
				padding-left: 0px;
				padding-right: 0px;

				@media screen and (max-width: 950px) {
					border-right: 0px solid white;
				}
			}

			@media screen and (max-width: 950px) {
				height: initial;
			}
		}

		.header_table {
			height: 5%;

			@media screen and (max-width: 750px) {
				display: none;
			}

			@media screen and (max-width: 950px) {
				height: initial;
			}
		}

		.divInput {
			// border: 1px solid #d3d3d3;
			padding: 0.5em;
			height: 100%;

			.inputForm {
				margin-bottom: 10px;

				.inputText {
					font-size: 14px;
					margin-bottom: 2px;
					color: #5e5e5e;
				}

				.inputValue {
					width: 100%;
					padding: 5px;
					border-radius: 5px;
					border: none;
					background-color: #f3f3f3;
				}
			}
		}

		.tableHead {
			margin-bottom: 0px;

			th {
				padding-top: 5px;
				padding-left: 2px;
				padding-right: 2px;

				font-size: 12px;
				font-weight: 500;
				border: none;
				color: #5e5e5e;
			}
		}

		.tableDetail {
			.tableDetailHead {
				margin-bottom: 0px;

				.headTh {
					padding-top: 5px;
					padding-left: 2px;
					padding-right: 2px;

					font-size: 12px;
					font-weight: 500;
					border: none;
					color: #5e5e5e;
				}

				@media screen and (max-width: 750px) {
					display: contents;
				}
			}

			td {
				padding-top: 5px;
				padding-left: 2px;
				padding-right: 2px;
			}

			.lotAssigned {
				display: flex;
				justify-content: center;
				border: 1px solid #5a8217;
				padding: 5px;
				border-radius: 5px;
			}

			@media screen and (max-width: 750px) {
				overflow-x: auto;
				width: 60em;
			}
		}

		.files {
			.row_file {
				border-bottom: 1px solid #81ba43;
				padding-bottom: 5px;

				.file_number {
					@media screen and (max-width: 950px) {
						display: none;
					}
				}

				.file_name {
					cursor: pointer;

					&:hover {
						color: #2977ca;
					}
				}

				.delete_file {
					width: 1em;
					height: 1em;
					cursor: pointer;
				}
			}
		}
	}

	.total {
		text-align: right;
		font-size: 17px;

		@media screen and (max-width: 950px) {
			font-size: 20px;
		}
	}

	.iconAdd {
		width: 1.5em;
		height: 1.5em;
		cursor: pointer;
	}

	.buttons {
		display: flex;
		justify-content: flex-end;

		@media screen and (max-width: 950px) {
			margin-top: 1em;
			justify-content: space-around;

			flex-direction: column;
			align-items: center;
		}

		.buttonClose {
			width: 15%;
			display: flex;
			justify-content: center;
			padding: 0px 10px;

			@media screen and (max-width: 950px) {
				width: 100%;
			}

			div {
				text-align: center;
				width: 100%;
				font-size: 15px;
				background-color: #d7373f;
				padding-top: 5px;
				padding-bottom: 7px;
				padding-left: 1.5em;
				padding-right: 1.5em;
				border-radius: 5px;
				font-weight: 400;
				color: white;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;

				@media screen and (max-width: 950px) {
					width: 100%;
					text-align: center;
					margin-bottom: 5px;
				}
			}
		}

		.buttonSave {
			width: 15%;
			display: flex;
			justify-content: center;
			padding: 0px 10px;

			@media screen and (max-width: 950px) {
				width: 100%;
			}

			div {
				width: 100%;
				text-align: center;
				font-size: 15px;
				background-color: #5a8217;
				padding-top: 5px;
				padding-bottom: 7px;
				padding-left: 1.5em;
				padding-right: 1.5em;
				border-radius: 5px;
				font-weight: 400;
				color: white;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;

				@media screen and (max-width: 950px) {
					width: 100%;
					text-align: center;
					margin-bottom: 5px;
				}
			}

			&.disabled {
				div {
					background-color: #7d8f5f;
				}
			}
		}
	}
}

.div_suggestion {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 10%;
	position: relative;

	.buttonSuggestions {
		cursor: pointer;
		fill: #d7373f;
	}

	.saveAsList {
		z-index: 1;
		position: absolute;
		background-color: white;
		padding-top: 5px;
		padding-bottom: 5px;
		min-width: 12em;
		border-radius: 5px;
		right: 64%;
		display: none;
		box-shadow: 5px 5px 5px #dfe1e6;
		top: 3px;
		left: 29px;

		&.active {
			display: block;
		}

		.saveAsHr {
			margin-top: 0.5em;
			margin-bottom: 0.5em;
		}

		.saveAsTitle {
			font-size: 12px;
			padding-left: 8px;
			padding-right: 8px;
			font-style: italic;
			color: #81ba43;
		}

		.saveAsNew {
			font-size: 12px;
			padding-bottom: 5px;
			padding-left: 8px;
			padding-right: 8px;
			cursor: pointer;

			&:hover {
				background-color: #eff0f2;
			}
		}

		.saveAsListItem {
			font-size: 12px;
			padding-bottom: 5px;
			padding-left: 8px;
			padding-right: 8px;
			cursor: pointer;

			span {
				margin-left: 15px;
			}

			&.active {
				background-image: url("../../../../assets/images/desktop/check-save-as.svg");
				background-position: left;
				background-repeat: no-repeat;
				background-size: 25px 10px;
				background-position-y: 5px;
			}

			&:hover {
				background-color: #eff0f2;
			}
		}
	}
}

.listButtons {
	display: flex;
	justify-content: flex-end;
	align-items: center;

	.button {
		cursor: pointer;
		width: 1.7em;
		margin: 0px 3px;
	}
}
